import type { Variant } from '../types';

export interface SpinnerProps {
  variant?: Variant;
  size?: 'sm' | 'md';
  /** Border spinner (default) or grow spinner. */
  grow?: boolean;
  label?: string;
}

export function Spinner({ variant = 'primary', size = 'md', grow = false, label = 'Loading…' }: SpinnerProps) {
  const base = grow ? 'spinner-grow' : 'spinner-border';
  const classes = [base, size === 'sm' ? `${base}-sm` : '', `text-${variant}`].filter(Boolean).join(' ');
  return (
    <div className={classes} role="status">
      <span className="visually-hidden">{label}</span>
    </div>
  );
}
